import { useMemo } from "react";
import { filterRepoItems } from "../utils/filterRepoItems";

export function useFilteredRepoItems(
  items,
  { repoView, currentFolder, searchTerm, dayFilter, typeFilters, appliedSortOrder, appliedFolderSort },
) {
  return useMemo(
    () =>
      filterRepoItems({
        items,
        repoView,
        currentFolder,
        searchTerm,
        dayFilter,
        typeFilters,
        appliedSortOrder,
        appliedFolderSort,
      }),
    [
      items,
      repoView,
      currentFolder,
      searchTerm,
      dayFilter,
      typeFilters,
      appliedSortOrder,
      appliedFolderSort,
    ],
  );
}
